import React from 'react';
import SeverityFace from '../SeverityFace';
import { SEVERITY_LEVELS, SEVERITY_SCALE } from '../../../../constants/journey';
import styles from './SeverityLegend.module.css';

const SeverityLegend = () => (
	<ul className={styles.legend}>
		{SEVERITY_LEVELS.map((level) => (
			<li key={level} className={styles.item}>
				<SeverityFace rating={level} size={20} showTitle={false} />
				<span className={styles.label}>{SEVERITY_SCALE[level].label}</span>
			</li>
		))}
	</ul>
);

export default SeverityLegend;
